/* Shorts (sections/main-shorts.liquid, his ask 09-30): orders the feed, plays it, pauses it. Each clip runs --dur
   (the section's seconds), then the feed scrolls to the next; a swipe moves one product and play carries on from
   there. A tap on the clip, the orb or Space pauses; Buy and Share pause too, so Back lands on the same product.
   Buy tags the cart _via: shorts (once a visit) so orders that went through here can be counted. Loaded on that page
   only; the card listeners in portal.js look for .card and .attachment and never see a short. */
(function () {
  var root = document.querySelector('[data-shorts]');
  if (!root) { return; }
  var feed = root.querySelector('[data-shorts-feed]');
  var end = root.querySelector('[data-shorts-end]');
  var fill = root.querySelector('[data-shorts-fill]');
  var titleEl = root.querySelector('[data-shorts-title]');
  var stateEl = root.querySelector('[data-shorts-state]');
  var posEl = root.querySelector('[data-shorts-pos]');
  var orb = root.querySelector('[data-shorts-action="play"]');
  var closeLink = root.querySelector('[data-shorts-close]');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var store = function (k, v) {
    try {
      if (v === undefined) { return window.sessionStorage.getItem(k); }
      window.sessionStorage.setItem(k, v);
    } catch (e) {}
    return null;
  };
  root.style.setProperty('--dur', (parseFloat(root.getAttribute('data-seconds')) || 5) + 's');
  document.documentElement.classList.add('xp-locked');

  /* The order (his 09-30): random, the first clip always one of the hero six or Featured, the rest of them mixed one
     to one with random picks right behind it, then everything else at random. A Back or a reload (the URL carries
     #handle) keeps this visit's order and opens on that product, paused. */
  var shuffle = function (a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  };
  var all = Array.prototype.slice.call(feed.querySelectorAll('.short[data-handle]'));
  var byHandle = {};
  all.forEach(function (el) { byHandle[el.getAttribute('data-handle')] = el; });
  var key = 'shorts:' + root.getAttribute('data-collection');
  var hash = '';
  try { hash = decodeURIComponent(location.hash.slice(1)); } catch (e) {}
  var resumed = !!(hash && byHandle[hash]);
  var items = null;
  if (resumed) {
    var saved = null;
    try { saved = JSON.parse(store(key)); } catch (e) {}
    if (saved && saved.length) {
      var used = {};
      items = [];
      saved.forEach(function (h) { if (byHandle[h] && !used[h]) { used[h] = true; items.push(byHandle[h]); } });
      all.forEach(function (el) { if (!used[el.getAttribute('data-handle')]) { items.push(el); } });
    }
  }
  if (!items) {
    var front = shuffle(all.filter(function (el) { return el.getAttribute('data-front') === '1'; }));
    var rest = shuffle(all.filter(function (el) { return el.getAttribute('data-front') !== '1'; }));
    var first = front.shift();
    items = (first ? [first] : []).concat(shuffle(front.concat(rest.splice(0, front.length))), rest);
  }
  items.forEach(function (el) { feed.insertBefore(el, end); });
  store(key, JSON.stringify(items.map(function (el) { return el.getAttribute('data-handle'); })));
  feed.classList.add('is-ready');
  if (!items.length) { return; }

  var current = -1;
  var playing = false;
  var touching = false;
  var owed = false;
  var resume = false;
  var noteTimer = 0;

  /* Images carry data-srcset; a product's load when it is up next (this one, two ahead, one behind). */
  var load = function (i, first) {
    var el = items[i];
    if (!el) { return; }
    var imgs = el.querySelectorAll('img[data-srcset]');
    for (var q = 0; q < imgs.length; q++) {
      if (first && q === 0) { imgs[q].setAttribute('fetchpriority', 'high'); }
      imgs[q].setAttribute('srcset', imgs[q].getAttribute('data-srcset'));
      imgs[q].removeAttribute('data-srcset');
    }
  };
  var status = function () {
    var which = current >= items.length ? 'data-stopped' : (playing ? 'data-playing' : 'data-paused');
    stateEl.textContent = root.getAttribute(which);
  };
  var note = function (text) {
    stateEl.textContent = text;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(status, 2000);
  };
  var setPlaying = function (on) {
    playing = on;
    root.classList.toggle('is-paused', !on);
    var label = root.getAttribute(on ? 'data-pause' : 'data-play');
    orb.setAttribute('aria-label', label);
    orb.setAttribute('title', label);
    status();
  };
  var run = function () {
    fill.classList.remove('is-run');
    void fill.offsetWidth;
    fill.classList.add('is-run');
  };
  /* The clip scrolling away keeps its last frame until it is out of view, then rests; a clip coming (back) on screen
     starts from its first frame with the seek bar. */
  var leave = function (el) {
    el.classList.add('is-leaving');
    window.setTimeout(function () {
      if (items[current] !== el) { el.classList.remove('is-on'); }
      el.classList.remove('is-leaving');
    }, 700);
  };
  var begin = function (el) {
    el.classList.remove('is-on', 'is-leaving');
    void el.offsetWidth;
    el.classList.add('is-on');
  };
  var activate = function (i) {
    if (i === current) { return; }
    if (items[current]) { leave(items[current]); }
    current = i;
    owed = false;
    if (i >= items.length) {
      fill.classList.remove('is-run');
      titleEl.textContent = titleEl.getAttribute('data-default');
      posEl.textContent = '';
      status();
      return;
    }
    var el = items[i];
    load(i); load(i + 1); load(i + 2); load(i - 1);
    begin(el);
    run();
    titleEl.textContent = el.getAttribute('data-file');
    posEl.textContent = root.getAttribute('data-pos').replace('[n]', i + 1).replace('[total]', items.length);
    status();
    try { history.replaceState(history.state, '', '#' + el.getAttribute('data-handle')); } catch (e) {}
  };
  var go = function (i, instant) {
    if (i < 0) { i = 0; }
    var el = i < items.length ? items[i] : end;
    feed.scrollTo({ top: el.offsetTop, behavior: reduce || instant ? 'auto' : 'smooth' });
  };
  var again = function () {
    setPlaying(true);
    go(0, true);
  };
  var toggle = function () {
    if (current >= items.length) { again(); return; }
    setPlaying(!playing);
  };

  /* The product on screen is the one at least 60% in view (each is the feed's full height, so one at a time). */
  var seen = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || entry.intersectionRatio < 0.6) { return; }
      var i = entry.target === end ? items.length : items.indexOf(entry.target);
      if (i === items.length && current !== i) { setPlaying(false); }
      activate(i);
    });
  }, { root: feed, threshold: [0.6] });
  items.forEach(function (el) { seen.observe(el); });
  seen.observe(end);

  /* The clip is over when its seek bar fills; never scroll out from under a finger (the next step waits for it). */
  fill.addEventListener('animationend', function () {
    if (!playing || document.hidden) { return; }
    if (touching) { owed = true; return; }
    go(current + 1);
  });
  feed.addEventListener('touchstart', function () { touching = true; }, { passive: true });
  var lift = function () {
    touching = false;
    if (!owed) { return; }
    owed = false;
    var at = current;
    window.setTimeout(function () { if (playing && !touching && current === at) { go(current + 1); } }, 450);
  };
  feed.addEventListener('touchend', lift);
  feed.addEventListener('touchcancel', lift);

  /* Buy: pause, tag the cart once a visit (a modified click opens its tab untouched), then go. */
  var tagged = function () { return store('shorts:via') === '1'; };
  var tag = function (done) {
    if (tagged() || !window.fetch) { done(); return; }
    var over = false;
    var finish = function () { if (!over) { over = true; done(); } };
    window.setTimeout(finish, 800);
    window.fetch(root.getAttribute('data-cart-update'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { _via: 'shorts' } })
    }).then(function (r) { if (r.ok) { store('shorts:via', '1'); } }, function () {}).then(finish);
  };
  var share = function (el) {
    setPlaying(false);
    var url = new URL(el.getAttribute('data-url'), location.href).href;
    var copy = function () {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { note(root.getAttribute('data-copied')); }, function () {});
      }
    };
    if (navigator.share) {
      navigator.share({ title: el.getAttribute('data-title'), url: url }).catch(function (e) {
        if (!e || e.name !== 'AbortError') { copy(); }
      });
    } else {
      copy();
    }
  };
  feed.addEventListener('click', function (event) {
    var t = event.target;
    var buy = t.closest('[data-shorts-buy]');
    if (buy) {
      setPlaying(false);
      if (tagged()) { return; }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) { tag(function () {}); return; }
      event.preventDefault();
      tag(function () { window.location.href = buy.href; });
      return;
    }
    var sharer = t.closest('[data-shorts-share]');
    if (sharer) { share(sharer.closest('.short')); return; }
    if (t.closest('[data-shorts-action="again"]')) { again(); return; }
    if (t.closest('[data-shorts-stage]')) { toggle(); }
  });
  root.querySelector('.shorts__controls').addEventListener('click', function (event) {
    var b = event.target.closest('[data-shorts-action]');
    if (!b) { return; }
    var action = b.getAttribute('data-shorts-action');
    if (action === 'play') { toggle(); }
    if (action === 'prev') { go(Math.min(current, items.length) - 1); }
    if (action === 'next') { go(current + 1); }
  });

  /* Close: back to the page that opened the player, else the folder it plays. */
  var close = function (event) {
    var same = false;
    try { same = !!document.referrer && new URL(document.referrer).origin === location.origin; } catch (e) {}
    if (same && history.length > 1) {
      if (event) { event.preventDefault(); }
      history.back();
      return;
    }
    if (!event) { window.location.href = closeLink.href; }
  };
  closeLink.addEventListener('click', close);

  document.addEventListener('keydown', function (event) {
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey) { return; }
    var tagName = event.target && event.target.tagName;
    if (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') { return; }
    var k = event.key;
    if (k === ' ' || k === 'Spacebar') {
      if (tagName === 'BUTTON' || tagName === 'A') { return; }
      event.preventDefault();
      toggle();
    } else if (k === 'ArrowDown' || k === 'PageDown') {
      event.preventDefault();
      go(current + 1);
    } else if (k === 'ArrowUp' || k === 'PageUp') {
      event.preventDefault();
      go(Math.min(current, items.length) - 1);
    } else if (k === 'Escape') {
      close();
    }
  });

  /* A hidden tab pauses, and picks up again when it comes back (unless it was already paused). */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (playing) { resume = true; setPlaying(false); }
    } else if (resume) {
      resume = false;
      setPlaying(true);
    }
  });

  var start = resumed ? items.indexOf(byHandle[hash]) : 0;
  load(start, true);
  if (start > 0) { feed.scrollTop = items[start].offsetTop; }
  /* Opened in a background tab: wait for it to be looked at (a hidden page must never race through the feed). */
  resume = !reduce && !resumed && document.hidden;
  setPlaying(!reduce && !resumed && !document.hidden);
  activate(start);
})();
